export enum IhmSystemStatusView {
  IN_BUILD = 'IN_BUILD',
  IN_PROGRESS = 'IN_PROGRESS',
  REVISING_ORDER = 'REVISING_ORDER',
  DRAFT = 'DRAFT',

  APPROVED = 'APPROVED',
  COMPLETE = 'COMPLETE',
  ORDER_IN_FLIGHT = 'ORDER_IN_FLIGHT',
  APPROVED_AUTO_INJECTED = 'APPROVED_AUTO_INJECTED',
  APPROVED_MANUAL_INJECTED = 'APPROVED_MANUAL_INJECTED',

  MANUAL_INJECTION = 'MANUAL_INJECTION',
  READ_ONLY = 'READ_ONLY',
  ASSIGNED = 'ASSIGNED',

  PENDING_APPROVAL = 'PENDING_APPROVAL',
  UNDER_REVIEW = 'UNDER_REVIEW',
  PENDING_MANUAL_INJECTION = 'PENDING_MANUAL_INJECTION',
  SUBMITTED = 'SUBMITTED',
  SYNCING = 'SYNCING',

  PARTIAL_UPDATED = 'PARTIAL_UPDATED',
  ESCALATED = 'ESCALATED',
  NEED_MORE_INFO = 'NEED_MORE_INFO',

  REJECTED = 'REJECTED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED'
}
